import {Languages} from "./translations/types";
import React, {useContext} from "react";
import {LanguageContext} from "../Context/LanguageContext";

const LangSelector = () => {
    const {lang, changeLanguage} = useContext(LanguageContext);

    return <div className="lang-selector">
        <select className="lang-selector__select" aria-label="Language" value={lang}
                onChange={event => changeLanguage(Number(event.target.value))}>
            <option value={Languages.EN}>English</option>
            <option value={Languages.RU}>Русский</option>
            <option value={Languages.CH}>中文</option>
        </select>
    </div>
}

export default LangSelector;
